// -------------------------------
// TDS AUTO PROCESS INTERFACES
// -------------------------------
export interface PendingAutoTds {
    FinancialYearID?: number;
    MonthYear?: string;           // YYYY-MM
    TaxRegimeID?: number;
    SurchargeCessID?: number;
    earning_head_ids?: number[];
}

// -------------------------------
// AUTO PROCESS TDS — START
// -------------------------------
export const startAutoProcessTdsFlow = (
    setPending: (data: PendingAutoTds | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {
    setPending({});
    pushAIChat("Sure! Which financial year should I process TDS for?");
    speak("Which financial year should I process TDS for?");

    window.dispatchEvent(
        new CustomEvent("ai-suggest-options", {
            detail: { type: "financial-year-tds" }
        })
    );
};

// -------------------------------
// AUTO PROCESS TDS — PROCESS
// -------------------------------
export const processPendingAutoTds = (
    text: string,
    pending: PendingAutoTds,
    setPending: (data: PendingAutoTds | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {

    // STEP 1 — FINANCIAL YEAR
    if (!pending.FinancialYearID) {
        const fyId = Number(text.replace(/[^0-9]/g, ""));

        if (!fyId) {
            pushAIChat("Please provide a valid financial year.");
            speak("Invalid financial year.");
            return;
        }

        setPending({ ...pending, FinancialYearID: fyId });

        pushAIChat("Which month should I process TDS for? (YYYY-MM)");
        speak("Which month should I process TDS for?");
        return;
    }

    // STEP 2 — MONTH YEAR
    if (!pending.MonthYear) {
        const isValid = /^\d{4}-\d{2}$/.test(text.trim());

        if (!isValid) {
            pushAIChat("Please provide month in YYYY-MM format.");
            speak("Invalid month format.");
            return;
        }

        setPending({ ...pending, MonthYear: text.trim() });

        pushAIChat("Which tax regime should be used?");
        speak("Which tax regime should be used?");

        window.dispatchEvent(
            new CustomEvent("ai-suggest-options", {
                detail: { type: "tax-regime-contri" }
            })
        );
        return;
    }

    // STEP 3 — TAX REGIME
    if (!pending.TaxRegimeID) {
        const regimeId = Number(text.replace(/[^0-9]/g, ""));

        if (!regimeId) {
            pushAIChat("Please select a valid tax regime.");
            speak("Invalid tax regime.");
            return;
        }

        setPending({ ...pending, TaxRegimeID: regimeId });

        pushAIChat("Which surcharge & cess should be applied?");
        speak("Which surcharge and cess should be applied?");

        window.dispatchEvent(
            new CustomEvent("ai-suggest-options", {
                detail: { type: "surcharge-cess" }
            })
        );
        return;
    }

    // STEP 4 — SURCHARGE & CESS
    if (!pending.SurchargeCessID) {
        const cessId = Number(text.replace(/[^0-9]/g, ""));

        if (!cessId) {
            pushAIChat("Please select a valid surcharge & cess.");
            speak("Invalid surcharge and cess.");
            return;
        }

        setPending({ ...pending, SurchargeCessID: cessId });

        pushAIChat("Which earning heads should be included?");
        speak("Which earning heads should be included?");

        window.dispatchEvent(
            new CustomEvent("ai-suggest-options", {
                detail: { type: "earnings-head-contri-tds", multi: true }
            })
        );
        return;
    }

    // STEP 5 — EARNING HEADS
// STEP 5 — EARNING HEADS (FINAL STEP)
if (!pending.earning_head_ids || pending.earning_head_ids.length === 0) {
    pushAIChat("Please select at least one earning head.");
    speak("Please select at least one earning head.");
    return;
}

// ✅ FINAL — AUTO PROCESS TDS
pushAIChat("Perfect! Processing TDS for all employees...");
speak("Processing TDS now.");

window.dispatchEvent(
    new CustomEvent("ai-auto-process-tds", {
        detail: {
            FinancialYearID: pending.FinancialYearID!,
            MonthYear: pending.MonthYear!,
            TaxRegimeID: pending.TaxRegimeID!,
            SurchargeCessID: pending.SurchargeCessID!,
            earning_head_ids: pending.earning_head_ids!,
        }
    })
);

setPending(null);
return;

};
